import React from 'react'
import PropTypes from 'prop-types'

const FormDashboardTextarea = React.forwardRef(({className, defaultValue, ...props}, ref) => {
  return (
    <textarea
      className={`rounded border py-2 px-4 text-sm ${className}`}
      style={{borderColor: '#ddd', whiteSpace: 'pre-line'}}
      defaultValue={defaultValue.replace('\\n', '\n')}
      ref={ref}
      {...props}
    />
  )
})

FormDashboardTextarea.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.number,
  defaultValue: PropTypes.string,
}

FormDashboardTextarea.defaultProps = {
  className: '',
  rows: 7,
  defaultValue: '',
}

export { FormDashboardTextarea }
